class RecommendationSwiper extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.swiperEl = this.querySelector('.swiper');

        if (!this.swiperEl) return;

        this.initSwiper();
    }

    initSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            navigation: {
                prevEl: this.querySelector('[data-swiper-button="prev"]'),
                nextEl: this.querySelector('[data-swiper-button="next"]'),
                disabledClass: "opacity-30 cursor-not-allowed",
            },
            a11y: {
                enabled: true,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },

        });
    }
}

customElements.define('recommendation-swiper', RecommendationSwiper);